module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('div', {
    staticClass: "pa-0 pl-2",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "cyan--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName))])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "title",
      "label": "Title",
      "id": "title",
      "required": ""
    },
    model: {
      value: (_vm.editedTitle),
      callback: function($$v) {
        _vm.editedTitle = $$v
      },
      expression: "editedTitle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "trial.editedDescription",
      "label": "Edit Trial Description",
      "id": "editedDescription",
      "multi-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedDescription),
      callback: function($$v) {
        _vm.editedDescription = $$v
      },
      expression: "editedDescription"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.editedEnrollment",
      "label": "Edit Trial Status",
      "items": _vm.enrollments,
      "item-value": "enrollmentId",
      "item-text": "enrollmentName",
      "id": "editedEnrollment",
      "max-height": "400",
      "hint": "Pick your enrollment",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedEnrollment),
      callback: function($$v) {
        _vm.editedEnrollment = $$v
      },
      expression: "editedEnrollment"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "trialLink",
      "label": "Edit Trial Link",
      "id": "trialLinks",
      "required": ""
    },
    model: {
      value: (_vm.editedLink),
      callback: function($$v) {
        _vm.editedLink = $$v
      },
      expression: "editedLink"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text cyan ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f254062","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Edit/EditTrialDetailsDialog.vue
// module id = 662
// module chunks = 1